module.exports = __webpack_public_path__ + "static/media/login-logo@2x.417649da.png";